import { useEffect, useState } from 'react'
import { ChannelType } from '../../models/conversations'
import { Popover } from '@mui/material';
import Avatar from '../shared/avatar.component';
import { UtilityService } from '../../services/UtilityService';
import { ActionLabels, ToasterTexts, appNote, buttonLabels, pageTitles } from '../shared/constants';
import { ArchivedIcon, BackMobileIcon, InstaBadgeIcon, LiveChatBlackandWhiteSmallIcon, MarkasReadIcon, MarkasUnreadIcon, SettingsVertiMobileIcon, TrashIcon, UnArchivedIcon, GoogleBusinessIcon, MessageDeliveredIcon, DisabledGridIcon, FbBadgeIcon, WatsappConversationCardIcon, LiveChatIcon, TicketLowIcon, TicketHighIcon, TicketMediumIcon, TicketingStatusFollowingIcon, TicketingStatusOpenIcon, TicketingStatusClosedIcon, BurgerMenuIcon } from '../../icon';
import ChannelContactInfoComponent from './channel-contact-info.component';
import { ToasterType } from '../shared/toaster/toaster.model';
import { LoadConnectMessages } from '../../actions';
import { useSelector } from 'react-redux';
import * as selector from "../../selectors/selectors"
import { useDispatch } from 'react-redux'
import { ChannelAccountModel, ChannelAccountStatus, ChanneTicketingPriority, ChanneTicketingStatus } from '../../models/channels/channels.model';
import setToast from '../../helpers/toaster.helper';
import { MenuItemRender } from '../shared/menu-item-render';
import Confirm_Dialog from '../shared/confirm-dialog.component';
import TicketingComponent from './channels-ticketing.component';
import { ChannelUserModel, ChannelUserStatus } from '../../models/users.model';
import { ChannelUserService } from '../../services/ChannelUserService';
import { ChannelConversationService } from '../../services/channels/ChannelConversationService';
import { AppRoutes } from '../routes/route.path';
import { useNavigate } from 'react-router';

interface Props {
    CardData: any;
    ActiveCardIndex: number;
    BackHandler: () => void
    HandelContactInfomobile: (x: boolean) => void;
    ActionsData: any;
}

const ConversationHistoryHeader = (props: Props) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const ChannelAccounts: ChannelAccountModel[] = useSelector(selector.Channels)
    const ChannelUsers: ChannelUserModel[] = useSelector(selector.ChannelUsers)
    const CurrentUser: ChannelUserModel = ChannelUserService.getCurrentUserFromLocalStorage();


    const [showContactInfo, setShowContactInfo] = useState<boolean>(false)
    const [isloading, setIsLoading] = useState<boolean>(false);
    const [showDeleteHistoryDialog, setShowDeleteHistoryDialog] = useState<boolean>(false)
    const [anchorEl, SetAnchorEl] = useState(null);


    const openContactInfo = () => {
        if (IsMobileDevice) {
            props.HandelContactInfomobile(true)
        }
        else {
            setShowContactInfo(true)
        }
    }

    const closeContactInfo = () => {
        setShowContactInfo(null)
    }

    useEffect(() => {
        closeContactInfo()
    }, [props.CardData])


    //mobile menu action 

    const handelArchive = (phoneNumber: string, archived: boolean, groupChatId: string) => {
        ChannelConversationService.setArchiveChannelConversation(CurrentUser.OrganizationID, props.CardData?.ID, !archived, CurrentUser.ID).then(res => {
            setToast(archived ? ToasterTexts.UNARCHIVE_SUCCESS : ToasterTexts.ARCHIVE_SUCCESS, ToasterType.SUCCESS)
            // LoadConnectMessages(dispatch, CurrentUser.OrganizationID)
        }).catch(err => { })
    }

    const closeDeleteHistoryDialog = (isConfim: boolean, event?: any) => {
        event.stopPropagation();
        if (isConfim) {
            setIsLoading(true)
            ChannelConversationService.deleteChannelConversation(CurrentUser.OrganizationID, props.CardData?.ID)
                .then(() => {
                    setToast(ToasterTexts.DELETE_SUCCESS, ToasterType.SUCCESS)
                    setIsLoading(false)
                    setShowDeleteHistoryDialog(false)
                    LoadConnectMessages(dispatch, CurrentUser.OrganizationID)
                    navigate(AppRoutes.CONVERSATIONS)
                }).catch((er) => {
                    navigate(AppRoutes.CONVERSATIONS)
                })

        }
        else {
            setShowDeleteHistoryDialog(false)
        }
    }

    const handelMarkAsRead = (event?: any) => {
        if (props.CardData?.UnReadCount > 0) {
            ChannelConversationService.readChannelConversation(CurrentUser.OrganizationID, props.CardData?.ID).then((res) => {
                setToast(ToasterTexts.MARK_AS_READ_SUCCESS, ToasterType.SUCCESS)
            }).catch(err => { })
        }
        else {
            ChannelConversationService.unReadChannelConversation(CurrentUser.OrganizationID, props.CardData?.ID).then((res) => {
                setToast(ToasterTexts.MARK_AS_UNREAD_SUCCESS, ToasterType.SUCCESS)
            }).catch(err => { })
        }
    }


    const optionData =
        [{
            Name: props.CardData.IsArchived ? ActionLabels.UNARCHIVE : ActionLabels.ARCHIVE,
            Icon: props.CardData.IsArchived ? UnArchivedIcon : ArchivedIcon,
            OnClick: () => handelArchive(props.CardData.PhoneNumber, props.CardData.IsArchived, props.CardData.GroupChat?.ID),
        },
        {
            Name: ActionLabels.DELETE,
            Icon: TrashIcon,
            OnClick: () => setShowDeleteHistoryDialog(true),
        },
        {
            Name: (props.CardData.GroupChat?.UnReadCount || props.CardData.UnReadCount) > 0 ? ActionLabels.MARK_AS_READ : ActionLabels.MARK_AS_UNREAD,
            Icon: (props.CardData.GroupChat?.UnReadCount || props.CardData.UnReadCount) > 0 ? MarkasReadIcon : MarkasUnreadIcon,
            OnClick: (e) => handelMarkAsRead(e),
        },
        ]


    const handleClickFilter = (event: React.MouseEvent<HTMLDivElement>) => {
        SetAnchorEl(event.currentTarget);
    };
    return (
        <>
            {
                <div className={`d-flex p-relative align-center justify-between ${IsMobileDevice ? "w-p-100 bb-primary-divider-1 h-8" : "bb-primary-divider-4 flex-direction"}`}>
                    <div className={`d-flex ${IsMobileDevice ? "justify-between align-center w-p-100 h-p-100" : "w-p-100"} `}>
                        <button className='d-flex py-1 ml-1 align-center' onClick={openContactInfo}>
                            {IsMobileDevice && <BackMobileIcon onClick={() => { props.BackHandler() }} className={"my-auto"} />}
                            <div>
                                <div className="d-flex mr-1 ml-1 p-relative my-auto">
                                    <Avatar Name={props.CardData?.Name} ImgSrc={props.CardData?.ProfilePicLink && props.CardData?.ProfilePicLink} Size={40} Status={IsMobileDevice ? (props.CardData?.OnlineStatus ? "online" : "offline") : undefined} StatusBorder='2px solid #ffff' StatusPosition={{ top: "-1px", right: "24px" }}>
                                    </Avatar>
                                    <div className={`p-absolute t-3 w-2 h-2 l-3 b-mobile-ticketing br-p-50 d-flex`}>
                                        {(ChannelAccounts?.find(x => x.ID === props.CardData?.AccountId)?.Status === ChannelAccountStatus.DELETED || ChannelAccounts?.find(x => x.ID === props.CardData?.AccountId)?.Status === ChannelAccountStatus.DISCONNECTED || ChannelAccounts?.find(x => x.ID === props.CardData?.AccountId)?.Status === ChannelAccountStatus.DISCONNECTED_BY_PLAN_EXPIRY) ? <LiveChatBlackandWhiteSmallIcon width={16} height={16} /> : props.CardData?.Type === ChannelType.FACEBOOK ? <FbBadgeIcon /> : props.CardData?.Type === ChannelType.INSTAGRAM ? <InstaBadgeIcon /> : props.CardData?.Type === ChannelType.LIVE_CHAT ? <LiveChatIcon width={16} height={16} /> : props.CardData?.Type === ChannelType.WHATSAPP ? <WatsappConversationCardIcon className={"w-2 h-2"} /> : <GoogleBusinessIcon className={"w-3 h-3"} />}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className="t-align-left w-space">
                                    <span className={`${IsMobileDevice ? "h4-medium" : "h2-regular"} pl-1 ph-no-capture`} >
                                        {
                                            UtilityService.trimMessage((props.CardData.Type !== ChannelType.LIVE_CHAT ? props.CardData?.FirstName + ' ' + props.CardData?.LastName : props.CardData.Name || props.CardData?.Name), IsMobileDevice ? 15 : 30)
                                        }
                                    </span>
                                </div>
                                <div className="d-flex pl-1">
                                    <div className='d-flex'>
                                        <div className={`color-channel-history-header  d-flex justify-center align-center  ${IsMobileDevice ? "h6-regular" : "h5-medium"} ph-no-capture`}>{ChannelAccounts?.find(x => x.ID === props.CardData?.AccountId)?.NickName || props.CardData?.Name.split('@')[1]}</div>
                                    </div>
                                    {props.CardData?.Type === ChannelType.LIVE_CHAT && props.CardData?.OnlineStatus && !IsMobileDevice ?
                                        <div className={`br-2 ml-2 d-flex align-center color-channel-history-header ${IsMobileDevice ? "footnote-medium" : "h5-medium"}`}>
                                            <MessageDeliveredIcon className={"mr-1"} />
                                            Online
                                        </div> :
                                        props.CardData?.Type === ChannelType.LIVE_CHAT && !IsMobileDevice &&
                                        <div className={`br-2 ml-2 d-flex align-center color-channel-history-header ${IsMobileDevice ? "footnote-medium" : "h5-medium"}`}>
                                            <DisabledGridIcon className={"mr-1"} />
                                            Offline
                                        </div>
                                    }
                                </div>
                            </div>
                        </button>
                        <div className='flex-1 h-p-100 d-flex align-center justify-flex-end pr-2 ml-auto'>
                            <div className=''>
                                <TicketingComponent
                                    ParticipantId={props.CardData.ID}
                                    AssignedTo={ChannelUsers?.find(x => x.ID === props.CardData?.Ticket?.Assigned_To)?.FullName === CurrentUser.FullName ? "You" : ChannelUsers?.find(x => x.ID === props.CardData?.Ticket?.Assigned_To)?.FullName || "UnAssigned"}
                                    Status={props.CardData?.Ticket?.Status}
                                    Priority={props.CardData?.Ticket?.Priority}
                                    TicketHandlers={ChannelUsers?.filter(x => x.UserStatus === ChannelUserStatus.ACTIVE).map(x => x.FullName === CurrentUser.FullName ? "You" : x.FullName)}
                                    CloseTicketingPopover={() => { SetAnchorEl(null) }}
                                />
                            </div>
                            <MenuItemRender ClassName={"h-3"} MenuData={optionData} MeetBallIcon={BurgerMenuIcon} />
                        </div>
                    </div>
                    {
                        showContactInfo &&
                        <div className='min-w-40 p-absolute t-1 r-0' style={{ zIndex: 1 }}>
                            <ChannelContactInfoComponent
                                CardTitle={pageTitles.CONTACT_INFO}
                                ActionsData={undefined}
                                OnlineStatus={props.CardData?.OnlineStatus}
                                Name={props.CardData?.Name}
                                ParticipantID={props.CardData?.ID}
                                PageName={ChannelAccounts?.find(x => x.ID === props.CardData?.AccountId)?.NickName || props.CardData?.Name.split('@')[1]}
                                CloseContactInfo={closeContactInfo}
                                ChannelType={ChannelAccounts?.find(x => x.ID === props.CardData?.AccountId)?.ChannelType}
                            />
                        </div>
                    }

                </div>
            }

            {showDeleteHistoryDialog &&
                <Confirm_Dialog
                    onClose={closeDeleteHistoryDialog}
                    Show={showDeleteHistoryDialog}
                    Text={appNote.CONVERSATION_DELETE}
                    ButtonName={buttonLabels.DELETE}
                    Loading={isloading}
                />
            }

            {Boolean(anchorEl) &&
                <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={() => { SetAnchorEl(null) }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    classes={{ paper: `w-p-100 mt-2 p-relative box-shadow-mobile-ticketing-pop-up` }}
                >
                    <div className='w-p-100 py-1' >
                        <TicketingComponent
                            ParticipantId={props.CardData.ID}
                            AssignedTo={ChannelUsers?.find(x => x.ID === props.CardData?.Ticket?.Assigned_To)?.FullName === CurrentUser.FullName ? "You" : ChannelUsers?.find(x => x.ID === props.CardData?.Ticket?.Assigned_To)?.FullName || "UnAssigned"}
                            Status={props.CardData?.Ticket?.Status}
                            Priority={props.CardData?.Ticket?.Priority}
                            TicketHandlers={ChannelUsers?.filter(x => x.UserStatus === ChannelUserStatus.ACTIVE).map(x => x.FullName === CurrentUser.FullName ? "You" : x.FullName)}
                            CloseTicketingPopover={() => { SetAnchorEl(null) }}
                        />
                    </div>
                </Popover>
            }
        </>
    )
}

export default ConversationHistoryHeader
